import jwtInterceptor from "@/shared/jwtInterceptor";

const apiUrl= process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PATH;

export class UserApi
{

  static async getUserInfoForEdit(id)
  {
    const url = apiUrl + 'admin/User/getInfoForEdit/'+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }

  static async getUserActivity(id)
  {
    const url = apiUrl + 'admin/User/getActivity/'+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }
}